// extracted by mini-css-extract-plugin
export default {"DocumentItem":"styles_DocumentItem__xFCF9","showItem":"styles_showItem__Zpb1G","DocumentItemNameInput":"styles_DocumentItemNameInput__6EzMq"};